import * as React from 'react'
import { BPMChart } from '../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../api'
import { Legend, Series } from 'devextreme-react/chart'

export const DownloadedFromChart: React.FunctionComponent<{ album: string }> = ({ album }) => {
    return (
        <BPMChart title='Downloaded From' type='doughnut' subTitle={'By Page'}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            onRequestLoad={(options, signal) => {
                return (BPMAnalyticsAPI.get<any>('album/downloaded_from', options, signal))
            }} additionalParams={{ album }} series={{
                valueField: 'count', argumentField: 'from_source', name: 'Downloads',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Album/charts/DownloadedFromChart.tsx